import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "offcanvas-footer" }

import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { languagesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import LanguagesObj from "@/utils/LanguagesObj";
import { useLanguages } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Languages',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { languages: allLanguages, isPending } = useLanguages();

const { handleSubmit, resetForm } = useForm({
  validationSchema: toTypedSchema(languagesSchema),
  initialValues: { languages: [] },
});

const languagesModel = useVeeField<number[]>("languages");

onMounted(() => {
  resetForm({
    values: {
      languages: session.value?.languages.map((l: any) => l.language_id) ?? [],
    },
  });
});

const languageOptions = computed(() =>
  allLanguages.value.map((l) => ({
    ...l,
    name: `${(LanguagesObj as any)[l.code]?.flag ?? ""} ${l.name}`.trim(),
    selected: languagesModel.$model.includes(l.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, languages: values.languages });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isPending))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_openBlock(), _createBlock(_component_CheckboxInput, {
            key: 1,
            options: languageOptions.value,
            model: _unref(languagesModel)
          }, null, 8, ["options", "model"]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormButton, {
        marginVertical: false,
        label: "Concluir",
        loading: submitting.value,
        onOnClick: _unref(submit)
      }, null, 8, ["loading", "onOnClick"])
    ])
  ], 64))
}
}

})